import React from 'react';
import { Button } from 'primereact/button';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { downloadCaseBulkFiles } from 'services/fileManager/fileManagerServices';
import useDownloadProgress from 'hooks/useDownloadProgress';
import DownloadTray from 'components/DownloadTray/DownloadTray';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { useActivityLogDownload } from 'hooks/useActivityLogDownload';

function DownloadCaseButton() {
  const { caseDetails } = useFileManagerContext();
  const { downloadFile, downloads, setDownloads, remove } = useDownloadProgress();
  const { addToast } = useToast();
  const { addDownloadActivity } = useActivityLogDownload();

  const handleDownloadCase = async () => {
    try {
      const response = await downloadCaseBulkFiles({ case_id: caseDetails?.case_id }, 'download_case');
      const data = response?.data ?? {};
      const totalFiles = data.file_count;

      addDownloadActivity({
        event_subtype: 'download_case',
        message: `Downloaded Case: ${caseDetails?.case_name ?? ''}`,
        event_items: {
          case_id: caseDetails?.case_id ?? '',
          case_name: caseDetails?.case_name ?? '',
          is_lead: caseDetails?.is_lead,
        },
      });

      downloadFile(data.download_url, data.filename, undefined, undefined, true, {
        persistSuccessInTray: true,
        successHeadline: 'Case files downloaded successfully',
        totalFiles,
      });
    } catch (error) {
      console.log('Error downloading case:', error);
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'Failed to download case');
    }
  };

  return (
    <>
      <Button label="Download Case" className="p-button-primary outline text-nowrap" onClick={handleDownloadCase} />
      {downloads?.length > 0 && <DownloadTray fileDownloads={downloads} onClose={() => setDownloads([])} onRemoveFileDownload={remove} />}
    </>
  );
}

export default DownloadCaseButton;
